import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

const SignatureFlagsDevModeSection = ({
  t,
  readOnly,
  classes,
  signatureFlagsTestMode,
  signatureFlagsTestConfig,
  onChangeMode,
  onChangeConfig,
  disabled,
}) => {
  return (
    <div>
      <div
        className={classes.flexItems + ' box-container'}
        style={{ justifyContent: 'flex-start', marginTop: '24px' }}
      >
        <div className='box'>
          <FormControlLabel
            label={
              <span style={{ color: '#000', fontSize: '1rem' }}>
                {t('Accounts.Terms.SignatureFlagsTestMode')}
              </span>
            }
            labelPlacement='start'
            control={
              <Switch
                sx={{ ml: '5.9rem' }}
                classes={{
                  switchBase: classes.iOSSwitchBase,
                  bar: classes.iOSBar,
                  icon: classes.iOSIcon,
                  iconChecked: classes.iOSIconChecked,
                  checked: classes.iOSChecked,
                }}
                checked={!!signatureFlagsTestMode}
                onChange={(e) => onChangeMode(e.target.checked)}
                value='check'
                disabled={disabled}
                color='primary'
              />
            }
            style={{ marginLeft: '8px', marginTop: '5px' }}
          />
        </div>
      </div>
      {signatureFlagsTestMode && (
        <DialogContent>
          <TextField
            margin='dense'
            id='SignatureFlagsTestConfig'
            label={t('Accounts.Terms.SignatureFlagsTestConfig')}
            placeholder={t('Accounts.Terms.SignatureFlagsTestConfigPlaceholder')}
            fullWidth
            variant='standard'
            multiline
            minRows={2}
            maxRows={4}
            value={
              Array.isArray(signatureFlagsTestConfig)
                ? signatureFlagsTestConfig.join(', ')
                : ''
            }
            onChange={(e) => {
              const raw = e.target.value || '';
              const parts = raw
                .split(',')
                .map((p) => p.trim())
                .filter((p) => p.length > 0);
              onChangeConfig(parts);
            }}
            InputProps={{
              readOnly: Boolean(readOnly),
            }}
          />
        </DialogContent>
      )}
    </div>
  );
};

SignatureFlagsDevModeSection.propTypes = {
  t: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  signatureFlagsTestMode: PropTypes.bool,
  signatureFlagsTestConfig: PropTypes.array,
  onChangeMode: PropTypes.func.isRequired,
  onChangeConfig: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SignatureFlagsDevModeSection;




// WEBPACK FOOTER //
// ./src/components/account-list/SignatureFlagsDevModeSection.js